import api from './api'

export default {
  async listarUsuarios() {
    const response = await api.get('/usuarios')
    return response.data
  },

  async buscarUsuario(id) {
    const response = await api.get(`/usuarios/${id}`)
    return response.data
  },

  async criarUsuario(dados) {
    // Incluir senha e roleIds no body
    const response = await api.post('/usuarios', dados)
    return response.data
  },

  async atualizarUsuario(id, dados) {
    const response = await api.put(`/usuarios/${id}`, dados)
    return response.data
  },

  async atualizarStatus(id, ativo) {
    const response = await api.put(`/usuarios/${id}/status`, { ativo })
    return response.data
  },

  async redefinirSenha(id) {
    const response = await api.post(`/usuarios/${id}/redefinir-senha`)
    return response.data
  },

  async mudarSenha(senhaAtual, novaSenha) {
    const response = await api.put('/usuarios/mudar-senha', {
      senhaAtual,
      novaSenha
    })
    return response.data
  },

  async atualizarRoles(usuarioId, roleIds) {
    const response = await api.put(`/usuarios/${usuarioId}/roles`, {
      roleIds: Array.isArray(roleIds) ? roleIds : Array.from(roleIds)
    })
    return response.data
  }
}

